import React from "react";
import Site from "./components/site/Site";
import { injectModels } from "./redux/injectModels";


function App() {
  return (
    <Site />
  );
}

export default injectModels(["profile"])(App);
